import * as concorde from '@epilot/concorde-elements'
import React from 'react'
import ReactDOM from 'react-dom'

/**
 * This function exposes some packages globally to be used by other scripts
 * ex. Corncorde is exposed here to be used by app developers without bundling it in their scripts
 *
 * Accepts a target window so the same globals can be injected into the app
 * block iframe, mirroring the parent journey and letting apps externalize them.
 *
 * TODO: lazy load instead
 */
export function setGlobalPackages(target: Window = window) {
  target.React = React
  target.ReactDOM = ReactDOM
  target.Concorde = concorde
}
